import {Pane, ThemeProvider} from 'evergreen-ui';
import React, {memo, ReactNode} from 'react';
    
import {providerAppTheme} from '../evergreen-theme';
import {Footer} from './Footer';
import {Header} from './Header';
import {LeftNavbar} from './LeftNavbar';
import { ProviderSelectionModal } from 'providerapp/component/ProviderSelectionModal';
import { useApplicationIsInternalAuth } from 'common/component/ApplicationRootContext';
import { NotificationToaster } from 'common';


type StandardLayoutProps = {
    children: ReactNode;
    hasFooter?: boolean;
    /**
     * A panel that sits beside the page content, right of it and outside the footer, running the
     * full height of the main area. The Contact Management drawer (BHPNPP-3241) lives here: it
     * narrows the content rather than covering it, so the table stays visible and clickable.
     */
    sidePanel?: ReactNode;
    customSelection?: 'Client Care' | 'Authorization' | 'Notification' | 'Client Offers - At Risk' | 'Submitted Requests' | 'Provider Metrics' | 'Anticipated Discharges' | 'Roster Management' | 'Audit Export' | 'Progress Portrait' | 'Contact Management';
};

export const ClientManagementLayout = memo(({customSelection = 'Client Care', children, hasFooter = true, sidePanel}: StandardLayoutProps) => {
    const isInternalAuth = useApplicationIsInternalAuth();
    const [showProviderSelectionModal, setShowProviderSelectionModal] = React.useState(false);
    return (
        <ThemeProvider value={providerAppTheme}>
            <NotificationToaster/>
            <Pane minHeight='100vh' className="portal-provider-bg"
                  display="flex"
                  flexDirection="column"
            >
                <Header changeProvider={() => setShowProviderSelectionModal(true)}/>
                <Pane className="portal-layout-main"
                      flexGrow={1}
                      display="flex"
                >
                    <LeftNavbar currentSelection={customSelection}/>
                    <Pane className="portal-layout-main-content"
                          flexGrow={1}
                          overflow="auto"
                          display="flex"
                          flexDirection="column"
                    >
                        {children}
                        {
                            hasFooter && <Footer/>
                        }
                    </Pane>
                    {sidePanel}
                </Pane> 
                {
                    isInternalAuth && <ProviderSelectionModal visible={showProviderSelectionModal} onClose={() => {setShowProviderSelectionModal(false)}}/>
                }
            </Pane>
        </ThemeProvider>
    );
});
